import React from "react";
import { useApp } from "@/context/AppContext";

const categoryKeys = ["all", "pesticides", "herbicides", "fertilizers", "seeds", "tools", "organic_pesticides", "organic_produce", "residue_free"];

const CategoryFilter = ({ active, onChange }) => {
  const { t } = useApp();
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0" data-testid="category-filter">
      {categoryKeys.map((key) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          data-testid={`cat-filter-${key}`}
          className={`category-chip whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium border ${
            active === key
              ? "bg-[#2D5A27] text-white border-[#2D5A27]"
              : "bg-white text-[#1E293B] border-[#E2E8F0] hover:border-[#2D5A27]"
          }`}
        >
          {t(key)}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
